import { useRef } from 'react';
import { deepEquals } from '../functions/deep-equals';

const usePropertyHistory = <T>(callback: (previous: T | undefined, current: T | undefined) => void, property: T) => {
  const previousProperty = useRef<T | undefined>(undefined);
  if (!deepEquals(previousProperty.current, property)) {
    callback(previousProperty.current, property);
    previousProperty.current = property;
  }
};

export default usePropertyHistory;
